import { Badge } from "@/components/ui/badge";
import { Plan } from "@/types/enums";
import { cn } from "@/lib/utils";

interface PlanBadgeProps {
  plan: Plan;
  className?: string;
}

const PLAN_CONFIG: Record<
  Plan,
  {
    label: string;
    variant: "default" | "secondary" | "destructive" | "outline";
    className: string;
  }
> = {
  [Plan.FREE]: {
    label: "FREE",
    variant: "outline",
    className: "bg-gray-50 text-gray-700 border-gray-300",
  },
  [Plan.PRO]: {
    label: "PRO",
    variant: "default",
    className: "bg-blue-100 text-blue-800 border-blue-300",
  },
  [Plan.PLUS]: {
    label: "PLUS",
    variant: "default",
    className: "bg-sky-100 text-sky-800 border-sky-300",
  },
  [Plan.PREMIUM]: {
    label: "PREMIUM",
    variant: "default",
    className: "bg-amber-100 text-amber-800 border-amber-300",
  },
  [Plan.STUDENT_PASS]: {
    label: "STUDENT",
    variant: "secondary",
    className: "bg-green-100 text-green-800 border-green-300",
  },
  [Plan.PRO_TRIAL]: {
    label: "TRIAL",
    variant: "outline",
    className: "bg-purple-100 text-purple-800 border-purple-300",
  },
};

export function PlanBadge({ plan, className }: PlanBadgeProps) {
  const config = PLAN_CONFIG[plan];

  return (
    <Badge
      variant={config.variant}
      className={cn(config.className, className)}
      aria-label={`Plan: ${config.label}`}
    >
      {config.label}
    </Badge>
  );
}
